import { useState, useRef } from 'react';
import { Flex } from '../../styles/stylesStyled';
import Spinner from '../../components/common/Spinner';
import { AnimatePresence } from 'framer-motion';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import {
  getConversions,
  getInvoices,
  getTransactions,
  getWithdrawals,
  getTransfers
} from '../../slices/accounting-slice';
import { PageTitle, TabSelectButton } from '../../styles/GlobalComponents';
import { InvoicesPage } from './sections/Invoices';
import { TransactionsPage } from './sections/Transactions';
import { WithdrawalsPage } from './sections/Withdrawals';
import { ConversionsPage } from './sections/TopUps';
import { Tabs } from '../MyTeamBackoffice/MyTeamBackofficeStyled';
import { TransfersPage } from './sections/Tranfsers/Transfers';
import { useHistory, useLocation } from 'react-router-dom';
import { EARNINGS } from '../../routes/routes';

interface LocationState {
  from?: string;
}

const Accounting = () => {
  const { t } = useTranslation('accounting');

  const location = useLocation();

  const dispatch = useAppDispatch();
  const {
    invoices,
    transactions,
    withdrawals,
    conversions,
    transfers,
    loading
  } = useAppSelector((state) => state.accounting);

  const state = location.state as LocationState;

  const [tab, setTab] = useState(state?.from === EARNINGS ? 5 : 1);
  const [countInvoices, setCountInvoices] = useState(50);
  const [countTransactions, setCountTransactions] = useState(50);
  const [countWithdrawals, setCountWithdrawals] = useState(50);
  const [countConversions, setCountConversions] = useState(50);
  const [countTransfers, setCountTransfers] = useState(50);
  const [lastWeekStartDate, setLastWeekStartDate] = useState<number | null>(
    null
  );
  const numberOfPage = 1;

  useEffect(() => {
    if (tab === 1) {
      if (countInvoices <= 100) {
        dispatch(getInvoices({ countInvoices, lastWeekStartDate }));
      }
    } else if (tab === 2) {
      if (countTransactions <= 100) {
        dispatch(getTransactions({ countTransactions, numberOfPage }));
      }
    } else if (tab === 3) {
      if (countWithdrawals <= 100) {
        dispatch(getWithdrawals({ countWithdrawals, numberOfPage }));
      }
    } else if (tab === 4) {
      if (countConversions <= 100) {
        dispatch(getConversions({ countConversions, numberOfPage }));
      }
    } else if (tab === 5) {
      if (countTransfers <= 100) {
        dispatch(getTransfers({ countTransfers, numberOfPage }));
      }
    }
  }, [
    dispatch,
    tab,
    countInvoices,
    countTransactions,
    countWithdrawals,
    countConversions,
    lastWeekStartDate,
    countTransfers
  ]);

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom dark>
      <div style={{ marginBottom: 100 }}>
        <PageTitle>{t('accounting')}</PageTitle>

        <Tabs>
          <TabSelectButton selected={tab === 1} onClick={() => setTab(1)}>
            <div>{t('invoices')}</div>
          </TabSelectButton>
          <TabSelectButton selected={tab === 2} onClick={() => setTab(2)}>
            <div>{t('transactions')}</div>
          </TabSelectButton>
          <TabSelectButton selected={tab === 3} onClick={() => setTab(3)}>
            <div>{t('withdrawals')}</div>
          </TabSelectButton>
          <TabSelectButton selected={tab === 4} onClick={() => setTab(4)}>
            <div>{t('top_ups')}</div>
          </TabSelectButton>
          <TabSelectButton selected={tab === 5} onClick={() => setTab(5)}>
            <div>Transfers</div>
          </TabSelectButton>
        </Tabs>
        <AnimatePresence exitBeforeEnter>
          {tab === 1 && (
            <InvoicesPage
              invoices={invoices}
              setLastWeekStartDate={setLastWeekStartDate}
              setCountInvoices={setCountInvoices}
              countInvoices={countInvoices}
            />
          )}

          {tab === 2 && (
            <TransactionsPage
              transactions={transactions}
              setCountTransactions={setCountTransactions}
              countTransactions={countTransactions}
            />
          )}

          {tab === 3 && (
            <WithdrawalsPage
              withdrawals={withdrawals}
              setCountWithdrawals={setCountWithdrawals}
              countWithdrawals={countTransactions}
            />
          )}

          {tab === 4 && (
            <ConversionsPage
              conversions={conversions}
              setCountConversions={setCountConversions}
              countConversions={countConversions}
            />
          )}

          {tab === 5 && (
            <TransfersPage
              transfers={transfers}
              setCountTransfers={setCountTransfers}
              countTransfers={countTransfers}
            />
          )}
        </AnimatePresence>
      </div>
    </AnimatedDashboard>
  );
};

export default Accounting;
